import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/hyundai-second-hand-romania/")({
  head: () => routeHead("/hyundai-second-hand-romania/"),
  beforeLoad: () => {
    throw redirect({ href: "/cars/hyundai", statusCode: 301, replace: true });
  },
});
